import { Inject, Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { HttpClient } from '@angular/common/http';
import { Observable, take } from 'rxjs';
import { CONFIG, ENVIRONMENT } from '@domgen/dgx-fe-config';
import { AppConfig } from 'apps/dg-self-fix/src/app/models/config/app-config.type';

export type assistanceType = 'Repair' | 'Care tips' | 'None';

export interface PlanItem {
  manufacturer: string;
  model_number: string;
  code: string;
  code_description: string;
}

export interface PlanDetails {
  planNumber: string;
  repairAction: string;
  repairPayment: string;
  serviceAction: string;
  item: PlanItem;
  directReferral: Record<string, unknown>;
  planState: string;
  companyCode: string;
  countryCode: string;
  planCategoryCode: string;
  bookingOEM: string;
  productType: string;
}

export interface PlanClaim {
  plan_number: string;
  plan_state: string;
  plan_start: string;
  plan_expiry: string;
  plan_contract_type: string;
  plan_contract_type_code: string;
  plan_contract_product_type: string;
  plan_owner_type: string;
  item: PlanItem;
}

export interface PlanDetailsResponse {
  status: string;
  result: PlanDetails;
}

export interface PlansResponse {
  status: string;
  result: { plans: PlanClaim[] };
}

@Injectable({
  providedIn: 'root',
})
export class MyAccountService extends ApiService<any> {
  constructor(
    http: HttpClient,
    @Inject(CONFIG) private readonly config: AppConfig
  ) {
    super(http, config.authApi, '');
  }

  getPlanClaims(planNumber: string): Observable<PlanDetailsResponse> {
    return this.post<{ planNumber: string }, PlanDetailsResponse>(
      { planNumber },
      'get-plan-claims'
    );
  }

  getAllPlans(): Observable<PlansResponse> {
    return this.post<{}, PlansResponse>({}, 'get-all-plans');
  }

  public callSignout(): Observable<null> {
    return this.post<{}, null>({}, 'signout');
  }

  redirectToLogin() {
    window.location.href = this.config.myAccountLogoutPage ?? '';
  }
}
